import { debounce } from 'debounce';

var ScreensizeMapKeyEnum;
(function (ScreensizeMapKeyEnum) {
    ScreensizeMapKeyEnum["Xs"] = "xs";
    ScreensizeMapKeyEnum["Sm"] = "sm";
    ScreensizeMapKeyEnum["Md"] = "md";
    ScreensizeMapKeyEnum["Lg"] = "lg";
    ScreensizeMapKeyEnum["Xl"] = "xl";
})(ScreensizeMapKeyEnum || (ScreensizeMapKeyEnum = {}));
var screensizeMap = {
    xs: {
        min: 0,
        max: 575,
    },
    sm: {
        min: 576,
        max: 767,
    },
    md: {
        min: 768,
        max: 991,
    },
    lg: {
        min: 992,
        max: 1199,
    },
    xl: {
        min: 1200,
        max: 9999,
    },
};
function checkIsTouchDevice() {
    var prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
    var mq = function (query) { return window.matchMedia(query).matches; };
    // @ts-ignore
    if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
        return true;
    }
    var query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
    return mq(query);
}
var isTouchDevice = checkIsTouchDevice();
var getSize = function (width) {
    var sizeKeys = ['xs', 'sm', 'md', 'lg', 'xl'];
    if (width === 0) {
        return sizeKeys[0];
    }
    for (var i = 0; i < sizeKeys.length; i += 1) {
        var sizeKey = sizeKeys[i];
        if (screensizeMap[sizeKey].min < width && screensizeMap[sizeKey].max >= width) {
            return sizeKey;
        }
    }
    // Worst case, no one matches
    return 'xs';
};
var minWidth = function (width, size) {
    return width >= screensizeMap[size].min;
};
var maxWidth = function (width, size) {
    return width <= screensizeMap[size].max;
};
var only = function (width, size) {
    return minWidth(width, size) && maxWidth(width, size);
};
var between = function (width, sizeA, sizeB) {
    return minWidth(width, sizeA) && maxWidth(width, sizeB);
};
function arMediaQuery(payload) {
    var windowWidth = payload.windowWidth, pageContentWidth = payload.pageContentWidth;
    return {
        isTouchDevice: isTouchDevice,
        sizeMap: screensizeMap,
        pageContent: {
            minWidth: function (size) { return minWidth(pageContentWidth, size); },
            maxWidth: function (size) { return maxWidth(pageContentWidth, size); },
            only: function (size) { return only(pageContentWidth, size); },
            between: function (sizeA, sizeB) { return between(pageContentWidth, sizeA, sizeB); },
        },
        window: {
            minWidth: function (size) { return minWidth(windowWidth, size); },
            maxWidth: function (size) { return maxWidth(windowWidth, size); },
            only: function (size) { return only(windowWidth, size); },
            between: function (sizeA, sizeB) { return between(windowWidth, sizeA, sizeB); },
        },
    };
}
var ARMediaQuery = {
    install: function (app) {
        app.mixin({
            created: function () {
                var _this = this;
                this._arWindowWidth = window ? window.innerWidth : 0;
                this._arPageContentWidth = window ? window.innerWidth : 0;
                this._arMediaQuery = arMediaQuery({ windowWidth: window.innerWidth, pageContentWidth: window.innerWidth });
                // Do not take this out, otherwise update on our $arMediaQuery won't trigger vDOM rerendering
                app.util.defineReactive(this, '_arMediaQuery', this.$arMediaQuery);
                /**
                 * If either window size or page content size chagnes, we update _arMediaQuery,
                 * which does update $arMediaQuery.
                 * p.s: We also debounce it, in case the previous update comes after latest update
                 */
                this._updateArMediaQuery = debounce(function (payload) {
                    var oldWindowWidth = _this._arWindowWidth;
                    var oldPageContentWidth = _this._arPageContentWidth;
                    var newWindowWidth = payload.windowWidth;
                    var newPageContentWidth = payload.pageContentWidth;
                    // If window size and pageContent size both not changed, no need to update _arMediaQuery
                    if (getSize(oldWindowWidth) !== getSize(newWindowWidth) || getSize(oldPageContentWidth) !== getSize(newPageContentWidth)) {
                        _this._arMediaQuery = arMediaQuery({ windowWidth: payload.windowWidth, pageContentWidth: payload.pageContentWidth });
                    }
                    _this._arWindowWidth = newWindowWidth;
                    _this._arPageContentWidth = newPageContentWidth;
                }, 50);
            },
        });
        /**
         * Since updates on any variable with prefix "$" won't trigger vDOM rerendering,
         * we have to update _arMediaQuery and map it to $arMediaQuery
         */
        Object.defineProperty(app.prototype, '$arMediaQuery', {
            get: function () {
                return this.$root._arMediaQuery;
            },
            set: function (newVal) {
                return this.$root._arMediaQuery = newVal;
            }
        });
        app.prototype.$updateArMediaQuery = function (payload) {
            // Call _updateArMediaQuery
            this.$root._updateArMediaQuery(payload);
        };
    },
};

export default ARMediaQuery;
